import React, { useState, useEffect, useContext } from 'react'
import PropTypes from 'prop-types'
import setGraphQLErrors from '@orionx-dev/orionsoft-parts/lib/helpers/setGraphQLErrors'
import { Form, Field } from 'simple-react-form'
import Text from 'App/components/fields/Text'
import PhoneNumber from 'App/components/fields/PhoneNumber'
import styles from './styles.css'
import { formValidation } from './formData'
import Button from '@orionx-dev/orionsoft-parts/lib/components/Button'
import { KycContext } from 'App/KYC/Layout'
import getPhonePrefix from 'App/KYC/utils/getPhonePrefix'

function Kyc({ callNextStep, callBackStep }) {
  const { kyc, setKyc } = useContext(KycContext)
  const [form, setForm] = useState({
    address: '',
    phone: '',
    occupation: '',
  })
  const [invalidFields, setInvalidFields] = useState({})
  const [isFormValid, setIsFormValid] = useState(false)
  const [samplePhoneNumber, setSamplePhoneNumber] = useState('')

  useEffect(() => {
    const { phonePrefix, samplePhoneNumber } = getPhonePrefix()
    setSamplePhoneNumber(samplePhoneNumber)
    setForm(prevForm => ({ ...prevForm, phone: phonePrefix }))

    const isValid = isFormValidFunc(form)
    setIsFormValid(isValid)
  }, [])

  const save = async () => {
    try {
      setKyc({
        ...kyc,
        missingInfo: {
          ...form,
        },
      })
      callNextStep(true, true)
    } catch (error) {
      console.error(error)
      setGraphQLErrors(this, error)
    }
  }

  const validateFormInput = fieldName => {
    setInvalidFields(prevInvalidFields => ({
      ...prevInvalidFields,
      [fieldName]: !form[fieldName],
    }))
  }

  const setFieldColor = fieldName => ({
    borderColor: invalidFields[fieldName] ? '#EB5232' : '#BEBEC4',
    outline: invalidFields[fieldName] ? '#EB5232' : '',
  })

  const isFormValidFunc = values => {
    for (const field of formValidation) {
      const isFieldValid = field.isValid(values[field.fieldName])
      if (!isFieldValid) {
        console.error(`Field ${field.fieldName} is not valid`)
        return false
      }
    }
    return true
  }

  const formOnChange = val => {
    const isValid = isFormValidFunc(val)
    setForm(val)
    setIsFormValid(isValid)
  }

  return (
    <Form className={styles.form} state={form} onChange={formOnChange}>
      <div>
        <div className={styles.sectionTitle}>
          <h1>Ingresa tus datos personales</h1>
          <span>
            Toda tu información es confidencial y sólo se te pedirá esta vez para verificar y
            proteger tu identidad.
          </span>
        </div>

        <div className={styles.personalForm}>
          <div className={styles.inputWrapper}>
            <label className="tds-orionx-input__label">Profesión, ocupación u oficio</label>
            <Field
              fieldName="occupation"
              type={Text}
              placeholder="Ej. Abogado, Ingeniero Civil, Estudiante"
              label="Ocupación"
              onBlur={() => validateFormInput('occupation')}
              style={setFieldColor('occupation')}
              className="tds-orionx-input"
            />
          </div>

          <div className={styles.inputWrapper}>
            <label className="tds-orionx-input__label">Domicilio residencial</label>
            <Field
              fieldName="address"
              type={Text}
              placeholder="Dirección, Ciudad, País"
              label="Domicilio"
              onBlur={() => validateFormInput('address')}
              style={setFieldColor('address')}
              className="tds-orionx-input"
            />
          </div>

          <div className={styles.inputWrapper}>
            <label className="tds-orionx-input__label">Teléfono</label>
            <Field
              fieldName="phone"
              type={PhoneNumber}
              placeholder={samplePhoneNumber}
              label="Teléfono"
              onBlur={() => validateFormInput('phone')}
              style={setFieldColor('phone')}
              className="tds-orionx-input"
            />
          </div>
        </div>
        <div className={styles.submit}>
          <Button className={styles.buttonOutline} onClick={callBackStep}>
            Atrás
          </Button>
          <Button onClick={save} className={styles.buttonPrimary} disabled={!isFormValid}>
            Siguiente
          </Button>
        </div>
      </div>
    </Form>
  )
}

Kyc.propTypes = {
  callNextStep: PropTypes.func,
  callBackStep: PropTypes.func,
}

export default Kyc
